<template>
    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
        <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
        <div class="dropdown-menu dropdown-menu-right">
            <!-- Call the local handleLogout method -->
            <a class="dropdown-item" href="javascript:void(0);" @click.prevent="handleLogout">Logout</a>
        </div>
    </div>
    <!-- /Mobile Menu -->
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'MobileUserMenu',
    methods: {
        ...mapActions(['logout']),

        async handleLogout() {
            try {
                await this.logout();
                
                this.$router.push({ name: 'signin' });
            } catch (err) {
                console.error('Logout failed unexpectedly:', err);
                this.$router.push({ name: 'signin' }); 
            }
        }
    }
}
</script>
